import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../App.css";
import MedicationResources from "../MedicationResources";
import { sleep } from "../data/sleepData";
import Disclaimer from "../components/Disclaimer";
import TopBar from "../components/TopBar"; // ← reusable header (breadcrumb + avatar/login + white nav + modals)

const Sleep = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const supplementFromSearch = queryParams.get("treatment");

  const defaultSupplement = supplementFromSearch || Object.keys(sleep)[0];
  const [showSidebar, setShowSidebar] = useState(false);
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  const [selectedSupplement, setSelectedSupplement] = useState(defaultSupplement);
  const [selectedSummary, setSelectedSummary] = useState(null);
  const [showTreatmentSelector, setShowTreatmentSelector] = useState(true);

  useEffect(() => {
    if (supplementFromSearch && sleep[supplementFromSearch]) {
      setSelectedSupplement(supplementFromSearch);
    }
  }, [supplementFromSearch]);

  if (!sleep[selectedSupplement]) {
    return <h2>Error: Supplement not found.</h2>;
  }

  const { name, description, cost, insuranceCoverage, resources } =
    sleep[selectedSupplement];

  const handleViewSummary = (summary) => {
    setSelectedSummary(summary);
  };

  const handleCloseSummary = () => {
    setSelectedSummary(null);
  };

  return (
    <div className="page-container">
      {/* Reusable header (breadcrumb + account dropdown + white nav + modals) */}
      <TopBar breadcrumb={`Sleep Treatments > ${sleep[selectedSupplement]?.name}`} />

      <div className="medications-container">
        {isMobile && showTreatmentSelector && (
          <div className="treatment-selector-overlay">
            <div className="overlay-header">
              <button
                className="back-button"
                onClick={() => setShowTreatmentSelector(false)}
              >
                ← Back
              </button>
              <h2>Sleep Treatments</h2>
            </div>
            <div className="overlay-treatments">
              {Object.keys(sleep).map((item) => (
                <div
                  key={item}
                  className={`category-card ${
                    selectedSupplement === item ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedSupplement(item);
                    navigate(`/sleep?treatment=${encodeURIComponent(item)}`);
                    setShowTreatmentSelector(false);
                  }}
                >
                  <h3>{sleep[item].name}</h3>
                </div>
              ))}
            </div>
          </div>
        )}

        {isMobile && !showTreatmentSelector && (
          <button
            className="select-treatment-button"
            onClick={() => setShowTreatmentSelector(true)}
          >
            Select a Treatment
          </button>
        )}

        {/* ✅ Matches site-wide layout */}
        <div className="medication-layout">
          {/* Sidebar */}
          <div className={`sidebar ${isMobile && showSidebar ? "open" : ""}`}>
            <h2 className="sidebar-title">Sleep</h2>
            <p className="sidebar-description">
              Explore treatments to aid sleep quality and understand its
              importance for chronic pain.
            </p>
            <div className="sidebar-blocks">
              {Object.keys(sleep).map((supplement) => (
                <div
                  key={supplement}
                  className={`category-card ${
                    selectedSupplement === supplement ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedSupplement(supplement);
                    navigate(`/sleep?treatment=${encodeURIComponent(supplement)}`);
                    if (isMobile) setShowSidebar(false);
                  }}
                >
                  <h3>{sleep[supplement].name}</h3>
                </div>
              ))}
            </div>
          </div>

          {/* Two-Box Layout */}
          <div className="main-content">
            <div className="medication-info-box">
              <h2 className="medication-title">{name}</h2>
              <p className="medication-description">{description}</p>
              {cost && (
                <p className="medication-info">
                  <strong>Cost:</strong> {cost}
                </p>
              )}
              {insuranceCoverage && (
                <p className="medication-info">
                  <strong>Insurance Coverage:</strong> {insuranceCoverage}
                </p>
              )}
            </div>

            <div className="research-box">
              <h3 className="resources-title">Research on Sleep & Chronic Pain</h3>
              <MedicationResources
                resources={resources}
                onViewSummary={handleViewSummary}
              />
            </div>
          </div>
        </div>

        {selectedSummary && (
          <div className="summary-modal">
            <div className="modal-content">
              <button className="close-button" onClick={handleCloseSummary}>
                ×
              </button>
              <h3 style={{ textAlign: "left" }}>Summary</h3>
              <div className="summary-scroll">
                <p className="sidebar-description-left">{selectedSummary}</p>
              </div>
            </div>
          </div>
        )}
      </div>

      <Disclaimer />
    </div>
  );
};

export default Sleep;
